interface GradientTransitionProps {
  position: 'top' | 'bottom';
}

const GradientTransition = ({ position }: GradientTransitionProps) => {
  if (position === 'top') {
    // CSS mask creates true transparency fade - 100% visible at top, 0% at bottom
    return (
      <div 
        className="h-[60px] w-full"
        style={{
          background: `linear-gradient(135deg, 
            rgba(92, 157, 145, 0.5) 0%, 
            rgba(107, 122, 161, 0.4) 50%, 
            rgba(216, 124, 106, 0.5) 100%
          )`,
          maskImage: 'linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%)',
          WebkitMaskImage: 'linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%)'
        }}
      />
    );
  }
  
  // Bottom: 0% visible at top, 100% visible at bottom - seamlessly leads into footer
  return (
    <div 
      className="h-[60px] w-full"
      style={{
        background: `linear-gradient(to right, 
          rgba(107, 122, 161, 0.5) 0%, 
          rgba(216, 124, 106, 0.5) 100%
        )`,
        maskImage: 'linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 100%)',
        WebkitMaskImage: 'linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 100%)'
      }}
    />
  );
};

export default GradientTransition;
